import { ChangeDetectorRef, inject, type OnDestroy, Pipe, type PipeTransform } from '@angular/core';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { type Subscription } from 'rxjs';

@Pipe({
  name: 'overrideDisplayName',
  pure: false
})
export class OverrideDisplayNamePipe implements PipeTransform, OnDestroy {
  private lang: string;
  private subscription: Subscription;

  private translate = inject(TranslateService);

  constructor(private cdr: ChangeDetectorRef) {
    this.lang = this.translate.currentLang;
    this.subscription = this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.lang = event.lang;
      this.cdr.markForCheck(); // re-render with the new language. CONSTRUCTOR-injected ChangeDetectorRef
      // on purpose: inject(ChangeDetectorRef) in a pipe throws NG0201 (resolves the env injector, not
      // the host view). The constructor form resolves the host view's CDR (same as Angular's AsyncPipe),
      // so this stays a targeted markForCheck instead of a global ApplicationRef.tick().
    });
  }

  transform(item: { displayNames?: Record<string, string>; name?: string } | null | undefined): string {
    if (!item) {
      return '';
    }
    const displayName = item.displayNames?.[this.lang]?.trim();
    const fallback = typeof item.name === 'string' && item.name.trim() !== '' ? this.translate.instant(item.name) : '';

    return displayName || fallback;
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
